/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreRuoloAmministratoreGuard } from '@core/guards/ruolo-amministratore.guard';
import { PagesGestioneUtenteApprovaUtenteComponent } from './approva-utente/approva-utente.component';
import { PagesGestioneUtenteApprovaUtenteResolver } from './approva-utente/approva-utente.resolver';
import { PagesGestioneUtenteAttesaProfiloComponent } from './attesa-profilo/attesa-profilo.component';
import { PagesGestioneUtenteProfiloComponent } from './profilo/profilo.component';
import { PagesGestioneUtenteProfiloResolver } from './profilo/profilo.resolver';
import { PagesGestioneUtenteRicercaUtenteComponent } from './ricerca-utente/ricerca-utente.component';
import { PagesGestioneUtenteRicercaUtenteResolver } from './ricerca-utente/ricerca-utente.resolver';
import { PagesGestioneUtenteRichiestaProfiloComponent } from './richiesta-profilo/richiesta-profilo.component';
import { PagesGestioneUtenteRichiestaProfiloResolver } from './richiesta-profilo/richiesta-profilo.resolver';

@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'approva-utente',
            component: PagesGestioneUtenteApprovaUtenteComponent,
            resolve: { additionalInformation: PagesGestioneUtenteApprovaUtenteResolver },
            canActivate: [ CoreRuoloAmministratoreGuard ],
        },
        { path: 'attesa-profilo', component: PagesGestioneUtenteAttesaProfiloComponent, },
        {
            path: 'profilo',
            component: PagesGestioneUtenteProfiloComponent,
            resolve: { additionalInformation: PagesGestioneUtenteProfiloResolver },
        },
        {
            path: 'ricerca',
            component: PagesGestioneUtenteRicercaUtenteComponent,
            resolve: { additionalInformation: PagesGestioneUtenteRicercaUtenteResolver },
            canActivate: [ CoreRuoloAmministratoreGuard ],
        },
        {
            path: 'richiesta-profilo',
            component: PagesGestioneUtenteRichiestaProfiloComponent,
            resolve: { additionalInformation: PagesGestioneUtenteRichiestaProfiloResolver },
        },
        { path: '**', redirectTo: 'profilo' },
    ])],
    exports: [
        RouterModule,
    ]
})
export class PagesGestioneUtenteRoutingModule { }
